module.exports = __webpack_public_path__ + "img/proList1_03.d6666f64.jpg";